// Module
var code = "<div ng-click=\"$ctrl.click($event, item)\" ng-repeat=\"item in $ctrl.data track by item.id\" ng-class=\"{'selected': $ctrl.selected(item.id) }\" ng-transclude></div> ";
// Exports
module.exports = code;